import React from 'react';
import classNames from 'classnames';
import $ from 'jquery';
import _ from 'lodash';

// from http://codepen.io/CompuIves/pen/RNmwKV

class Bubble extends React.Component {

    constructor(props) {
        super(props);

        this.activate = this.activate.bind(this);
        this.windowSize = this.windowSize.bind(this);
    }

    componentDidMount() {
        this.container = $(this.props.containerSelector || 'body');
        this.circle = $('<div unselectable="on" id="circle"></div>');
        this.circleWrapper = $('<div id="circleWrapper"></div>');
        this.backgroundColor = this.props.backgroundColor || 'hotpink';
    }

    activate(event) {
        this.windowSize();

        let circle = this.circle.clone();
        let circleWrapper = this.circleWrapper.clone();
        let children = $(this.refs.el).children();

        circleWrapper.append(circle);
        this.container.append(circleWrapper);
        children.addClass('active');

        let wrapperCss = {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            position: 'fixed',
            left: '0',
            top: '0',
            'z-index': 3
        };

        let css = {
            position: 'absolute',
            'background-color': this.backgroundColor,
            width: 0,
            height: 0,
            'border-radius': '50%',
            left: event.pageX,
            top: event.pageY,
            'margin-left': 0,
            'margin-top': 0,
            'webkit-user-select': 'none',
            '-moz-user-select': 'none',
            '-ms-user-select': 'none',
            'z-index': 2
        };

        let animationProps = {
            width: (this.r * 2),
            height: (this.r * 2),
            'margin-left': -this.r,
            'margin-top': -this.r
        };

        let animationSettings = {
            duration: 400,
            easing: 'easeInOutCubic',
            queue: false,
            complete: () => {
                circleWrapper.detach();
                children.removeClass('active');
                if (_.isFunction(this.props.onComplete)) {
                    this.props.onComplete();
                }
            }
        };

        if (_.isFunction(this.props.onStart)) {
            this.props.onStart({css,animationProps,animationSettings});
        }

        circle.css(css);
        circleWrapper.css(wrapperCss);
        circle.animate(animationProps, animationSettings);
    }

    windowSize() {
        let width = window.innerWidth;
        let height = window.innerHeight;
        this.r = Math.sqrt(width * width + height * height);
    }

    render() {
        let {className, children, ...props} = this.props;
        let classes = {};

        return (<div onClick={this.activate} className={classNames(classes, className)} {...props} ref="el">
            {children}
        </div>);
    }

}

Bubble.propTypes = {
    containerSelector: React.PropTypes.string,
    backgroundColor: React.PropTypes.string,
    onComplete: React.PropTypes.func,
    onStart: React.PropTypes.func,
    className: React.PropTypes.string,
    children: React.PropTypes.node
};

export default Bubble;